import { render, staticRenderFns } from "./PolicyFinder.vue?vue&type=template&id=2607fafc&scoped=true"
import script from "./PolicyFinder.vue?vue&type=script&lang=js"
export * from "./PolicyFinder.vue?vue&type=script&lang=js"
import style0 from "./PolicyFinder.vue?vue&type=style&index=0&id=2607fafc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2607fafc",
  null
  
)

export default component.exports